import { render, staticRenderFns } from "./DepartmentIcon.vue?vue&type=template&id=ed1de01e"
import script from "./DepartmentIcon.vue?vue&type=script&lang=js"
export * from "./DepartmentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports